module.exports = __webpack_public_path__ + "static/sevastova-red-6259c53090805a2f3cd23ad35942d4bf.png";